export function FigmaRegistration() {
  return (
    <section className="bg-white py-[32px] md:py-[50px]">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] text-center mb-2">
          ¿Cómo registrar tu patinete?
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-center">
          Sin registro no hay seguro, y sin seguro no se puede circular legalmente
        </p>
        <p className="text-[#4a5565] text-[12px] md:text-[14px] leading-[18px] md:leading-[20px] text-center mb-[24px] md:mb-[36px]">
          Te guiamos paso a paso
        </p>

        {/* Steps */}
        <div className="hidden md:flex justify-between max-w-[1000px] mx-auto mb-10 relative">
          {/* Line */}
          <div className="absolute top-[18px] left-[93px] right-[93px] h-[1px] bg-[#D5D4D4]" />
          
          {/* Step 1 */}
          <div className="text-center w-[186px] relative">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center mx-auto mb-[10px]">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">1</span>
            </div>
            <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
              Accede al registro
            </h3>
            <a 
              href="https://sede.dgt.gob.es/es/vehiculos/matriculaciones-de-vehiculos/inscripcion-vmp/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#4a5565] text-[12px] leading-[16px] font-bold underline hover:text-[#ff6900]"
            >
              Sede electrónica de la DGT
            </a>
          </div>

          {/* Step 2 */}
          <div className="text-center w-[186px] relative">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center mx-auto mb-[10px]">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">2</span>
            </div>
            <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
              Prepara documentación
            </h3>
            <p className="text-[#4a5565] text-[12px] leading-[16px]">
              Reúne los documentos
            </p>
          </div>

          {/* Step 3 */}
          <div className="text-center w-[186px] relative">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center mx-auto mb-[10px]">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">3</span>
            </div>
            <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
              Realiza el pago
            </h3>
            <p className="text-[#4a5565] text-[12px] leading-[16px]">
              Paga la tasa administrativa
            </p>
          </div>

          {/* Step 4 */}
          <div className="text-center w-[186px] relative">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center mx-auto mb-[10px]">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">4</span>
            </div>
            <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
              Obtén certificado
            </h3>
            <p className="text-[#4a5565] text-[12px] leading-[16px]">
              Anota tu matrícula, está en la parte superior de la etiqueta
            </p>
          </div>

          {/* Step 5 */}
          <div className="text-center w-[186px] relative">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center mx-auto mb-[10px]">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">5</span>
            </div>
            <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
              Coloca etiqueta
            </h3>
            <p className="text-[#4a5565] text-[12px] leading-[16px]">
              Pon la etiqueta en lugar visible
            </p>
          </div>
        </div>

        {/* Mobile Steps - Vertical Layout */}
        <div className="flex md:hidden flex-col gap-6 mb-10 max-w-[400px] mx-auto">
          {/* Step 1 */}
          <div className="flex gap-4 items-start">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center flex-shrink-0">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">1</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
                Accede al registro
              </h3>
              <a 
                href="https://sede.dgt.gob.es/es/vehiculos/matriculaciones-de-vehiculos/inscripcion-vmp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#4a5565] text-[12px] leading-[16px] font-bold underline hover:text-[#ff6900]"
              >
                Sede electrónica de la DGT
              </a>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex gap-4 items-start">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center flex-shrink-0">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">2</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
                Prepara documentación
              </h3>
              <p className="text-[#4a5565] text-[12px] leading-[16px]">
                Reúne los documentos
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex gap-4 items-start">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center flex-shrink-0">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">3</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
                Realiza el pago
              </h3>
              <p className="text-[#4a5565] text-[12px] leading-[16px]">
                Paga la tasa administrativa
              </p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="flex gap-4 items-start">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center flex-shrink-0">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">4</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
                Obtén certificado
              </h3>
              <p className="text-[#4a5565] text-[12px] leading-[16px]">
                Anota tu matrícula, está en la parte superior de la etiqueta
              </p>
            </div>
          </div>

          {/* Step 5 */}
          <div className="flex gap-4 items-start">
            <div className="bg-white border-2 border-[#ff6900] rounded-full w-[36px] h-[36px] flex items-center justify-center flex-shrink-0">
              <span className="text-[#ff6900] text-[15px] font-bold leading-[28px]">5</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#101828] text-[14px] font-semibold leading-[20px] mb-1">
                Coloca etiqueta
              </h3>
              <p className="text-[#4a5565] text-[12px] leading-[16px]">
                Pon la etiqueta en lugar visible
              </p>
            </div>
          </div>
        </div>

        {/* Info Box */}
        <div className="max-w-[1016px] mx-auto">
          <div className="bg-[#FFF5E6] border border-[#ff6900] rounded-[8px] p-4 md:p-6">
            <div className="flex gap-3">
              <svg className="w-6 h-6 text-[#ff6900] flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                <path d="M12 8v4M12 16h.01" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <div>
                <h3 className="text-[#101828] text-[13px] md:text-[14px] font-semibold leading-[18px] md:leading-[20px] mb-3">
                  Desde el 30 de enero de 2026 es exigible el seguro obligatorio para matricular tu patinete eléctrico. Ten en cuenta que:
                </h3>
                <ul className="space-y-2 text-[#4a5565] text-[13px] md:text-[14px] leading-[18px] md:leading-[20px]">
                  <li className="flex gap-2">
                    <span className="text-[#ff6900] font-bold">•</span>
                    <span>El registro del patinete en la DGT es obligatorio previo a contratar el seguro</span>
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#ff6900] font-bold">•</span>
                    <span>Afecta a la mayoría de patinetes eléctricos en circulación</span>
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#ff6900] font-bold">•</span>
                    <span>Es un trámite muy sencillo y principalmente online</span>
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#ff6900] font-bold">•</span>
                    <span>No cumplir con la Ley puede suponer multas de hasta 800 €</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}